module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "span": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("\n      门店：\n      "), _c('el-select', {
    on: {
      "change": _vm.storeChange
    },
    model: {
      value: (_vm.shopId),
      callback: function($$v) {
        _vm.shopId = $$v
      },
      expression: "shopId"
    }
  }, _vm._l((_vm.shopListData), function(item) {
    return _c('el-option', {
      key: item.wxShopId,
      attrs: {
        "label": item.storeName,
        "value": item.wxShopId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addResource
    }
  }, [_vm._v("添加" + _vm._s(_vm.resourceName))])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.resourceLevelList,
      "height": _vm.wheight - 170,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "shopName",
      "label": "所属门店"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.resourceName + '名称'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "materialIds.length",
      "label": "服务项目数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.getDetail(scope.row.resourceLevelId)
            }
          }
        }, [_vm._v("查看")]), _vm._v("\n         \n        "), _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.updateResource(scope.row.resourceLevelId, scope.row.shopId)
            }
          }
        }, [_vm._v("编辑")]), _vm._v("\n         \n        "), _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.deleteResource(scope.row.resourceLevelId, scope.row.shopId)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详情",
      "visible": _vm.detailDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.detailDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    },
    model: {
      value: (_vm.detailForm),
      callback: function($$v) {
        _vm.detailForm = $$v
      },
      expression: "detailForm"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称："
    }
  }, [_c('span', {
    staticClass: "text-ellipsis",
    attrs: {
      "title": _vm.detailForm.name
    }
  }, [_vm._v(_vm._s(_vm.detailForm.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属门店："
    }
  }, [_vm._v("\n        " + _vm._s(_vm.detailForm.shopName) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "服务项目："
    }
  }, [_c('el-row', _vm._l((_vm.serverproject), function(item) {
    return _c('el-col', {
      key: _vm.index,
      attrs: {
        "span": 6,
        "title": item.label
      }
    }, [_c('span', [_vm._v(_vm._s(item))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "简介："
    }
  }, [_c('span', {
    staticClass: "text-ellipsis",
    attrs: {
      "title": _vm.detailForm.description
    }
  }, [_vm._v(_vm._s(_vm.detailForm.description))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示图："
    }
  }, [(_vm.detailForm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.detailForm.imageUrl ? _vm.wximageurl + _vm.detailForm.imageUrl : ''
    }
  }) : _c('span', [_vm._v("无图片")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.detailDialog = false
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-021be834", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-021be834"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/reservation/resourcesetting/list.vue
// module id = 2424
// module chunks = 0